import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import NaviBar from '@src/business-components/navibar';
import KvBox from '@src/business-components/kv-box';
import AdvantagePage from '@src/business-components/advantage-page';
import ProjectPage from '@src/business-components/project-page';
import SupplierPage from '@src/business-components/supplier-page';
import JoinPage from '@src/business-components/join-page';
import FooterPage from '@src/business-components/footer-page';
import Page from '../../components/page';

const styles = require('./index.less');
const Main = () => {
  const store = useStore(() => new MainStore());
  return (
    <Page className={styles.root}>
      <div className={styles.naviBarBox}>
        <NaviBar store={store.navibarStore} />
      </div>
      <div className={styles.content}>
        <KvBox store={store.kvBoxStore} />
        <AdvantagePage store={store.advantageStore} />
        <ProjectPage store={store.projectStore} />
        <SupplierPage store={store.supplierStore} />
        <JoinPage store={store.joinStore} />
        <FooterPage store={store.footerStore} />
      </div>
    </Page>
  );
};

export default observer(Main);
